import { render } from "./TheModal.vue?vue&type=template&id=106d1457&scoped=true"
import script from "./TheModal.vue?vue&type=script&lang=js"
export * from "./TheModal.vue?vue&type=script&lang=js"

import "./TheModal.vue?vue&type=style&index=0&id=106d1457&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106d1457"]])

export default __exports__